import React from 'react'
import OfferPageIntroInclusionItem from './OfferPageIntroInclusionItem'

interface Props {
  tileInclusionsList: Array<App.TileInclusion>;
}

function OfferPageIntroInclusions(props: Props) {
  const {
    tileInclusionsList,
  } = props

  return (
    <div>
      {tileInclusionsList.map(inclusion => (
        <OfferPageIntroInclusionItem key={inclusion.text} inclusion={inclusion} />
      ))}
    </div>
  )
}

export default OfferPageIntroInclusions
